import {
  React,
  Component,
  withRouter
} from 'imports/CommonImports';

import {PrimaryButton} from 'imports/DesignImports';

const styles = {
  finishSectionContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2em 0',
  },
}

class ProjectCalculation extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true,
      id: props.project.calculation.id,
      excel: props.project.calculation.excel_link
    }
  }

  render() {

    return(
      <div>
      <div>
      </div>
      <div style={{height: '100%', width: '100%', minHeight: '36em', maxHeight: '36em'}}>
        <iframe title="google-sheet" style={{height: '100%', width: '100%', minHeight: '36em', maxHeight: '36em'}} src={'https://docs.google.com/spreadsheets/d/' + this.state.excel}></iframe>
      </div>
      <div style={styles.finishSectionContainer}>
        {!this.props.project.calculation.is_finished && this.props.user.position === 'Líder de proyecto' ?
        <PrimaryButton
          label="Finalizar cálculo"
          onClick={() => this.props.finish('calculation', this.state.id, 'Has marcado el cálculo como finalizado')}/>
        : null}
      </div>
      </div>
    )
  }
}

export default withRouter(ProjectCalculation);



// WEBPACK FOOTER //
// ./src/components/files/ProjectCalculation.js